function t(t){var a=t.getRowLink,e=t.data,r=t.isSubRow;return a?{href:a(e,r)}:{}}export{t as default};
//# sourceMappingURL=getRowLinkProps.js.map
